var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: { "has-crossprice": _vm.hasCrossPrice } }, [
    _vm.showCrossPrice && _vm.hasCrossPrice
      ? _c("div", { staticClass: "crossprice" }, [
          _c("del", { staticClass: "text-muted small text-appearance" }, [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm._f("itemCrossPrice")(
                    _vm.currentVariation.prices.rrp.unitPrice.formatted
                  )
                ) +
                "\n        "
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "single__price-wrapper" }, [
      _c("div", { staticClass: "single__price price h1" }, [
        _c(
          "span",
          {
            attrs: { content: _vm.currentVariation.prices.default.price.value }
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm._f("currency")(
                    _vm.variationTotalPrice,
                    _vm.currentVariation.prices.default.currency
                  )
                ) +
                "\n    "
            )
          ]
        ),
        _vm._v(" "),
        _c("sup", [
          _vm._v(_vm._s(_vm.$translate("Ceres::Template.singleItemFootnote1")))
        ]),
        _vm._v(" "),
        _c("span", {
          attrs: { content: _vm.currentVariation.prices.default.currency }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "single__price-info" }, [
        _vm.currentVariation.unit
          ? _c("div", { staticClass: "base-price" }, [
              _vm.currentVariation.variation.mayShowUnitPrice
                ? _c("div", [
                    _vm._v("\n                    ("),
                    _c("span", { staticClass: "base-price-value" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm._f("specialOffer")(
                              _vm.variationGraduatedPrice.basePrice,
                              _vm.currentVariation.prices,
                              "basePrice"
                            )
                          ) +
                          "\n                "
                      )
                    ]),
                    _vm._v(")\n                ")
                  ])
                : _vm._e()
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          [
            _vm.isB2b ? [_vm._v("zzgl.")] : [_vm._v("inkl.")],
            _vm._v(
              " " +
                _vm._s(_vm.variationGraduatedPrice.vat.value) +
                "% MwSt. zzgl. "
            ),
            _vm._m(0),
            _vm._v(" "),
            _vm._t("additional-content-after-vat")
          ],
          2
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "versand-link",
        attrs: { href: "https://www.sweets-online.com/content/versand" }
      },
      [_c("u", [_vm._v("Versand")])]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }